export const formatDateSafe = (date: Date | string | null | undefined): string => {
  if (!date) return "-";
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return "-";
  return parsedDate.toLocaleDateString("pt-PT");
};